/**
 * MyPaShow – spelar upp demo-videon först när den är synlig i viewporten.
 * Sparar bandbredd och undviker onödig belastning under sidladdning.
 */
(function () {
  'use strict';

  var wraps = document.querySelectorAll('[data-mp-video-observe]');
  if (!wraps.length || !('IntersectionObserver' in window)) return;

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        var video = entry.target.querySelector('video');
        if (!video) return;
        if (entry.isIntersecting) {
          video.play().catch(function () {});
        } else {
          video.pause();
        }
      });
    },
    { threshold: 0.4 }
  );

  wraps.forEach(function (wrap) {
    observer.observe(wrap);
  });
})();
